"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usersPreferences = exports.usersEntity = exports.users = exports.tickets = exports.termsResponses = exports.terms = exports.taskTimeLogs = exports.tasks = exports.subscriptions = exports.spec = exports.promoCodeUsages = exports.projects = exports.projectPermissions = exports.projectNotes = exports.plans = exports.phases = exports.persons = exports.personRoles = exports.permissions = exports.partySubscriptions = exports.parties = exports.notifications = exports.logs = exports.localConfigs = exports.litigations = exports.legalObjects = exports.legalObjectCategories = exports.iapTransactions = exports.hearings = exports.groups = exports.googleProfile = exports.googleCalendars = exports.geo = exports.errors = exports.entityReports = exports.entityProfiles = exports.entityPreferences = exports.entityPlans = exports.entities = exports.empowerments = exports.emails = exports.documentVersions = exports.documentTemplates = exports.documentSeries = exports.documents = exports.devices = exports.contracts = exports.contactPersons = exports.companies = exports.clients = exports.clientPermissions = exports.clientNotes = exports.clientGroups = exports.clientBankAccounts = exports.clientAddresses = exports.auth = exports.bpiSubscriptions = exports.bpiNotifications = exports.billing = exports.appeals = exports.api = exports.ambassadorCodeUsages = exports.ambassadorCodes = exports.addendums = void 0;

var addendums = _interopRequireWildcard(require("./redux/addendums"));

exports.addendums = addendums;

var ambassadorCodes = _interopRequireWildcard(require("./redux/ambassadorCodes"));

exports.ambassadorCodes = ambassadorCodes;

var ambassadorCodeUsages = _interopRequireWildcard(require("./redux/ambassadorCodeUsages"));

exports.ambassadorCodeUsages = ambassadorCodeUsages;

var api = _interopRequireWildcard(require("./redux/api"));

exports.api = api;

var appeals = _interopRequireWildcard(require("./redux/appeals"));

exports.appeals = appeals;

var billing = _interopRequireWildcard(require("./redux/billing"));

exports.billing = billing;

var bpiNotifications = _interopRequireWildcard(require("./redux/bpiNotifications"));

exports.bpiNotifications = bpiNotifications;

var bpiSubscriptions = _interopRequireWildcard(require("./redux/bpiSubscriptions"));

exports.bpiSubscriptions = bpiSubscriptions;

var auth = _interopRequireWildcard(require("./redux/auth"));

exports.auth = auth;

var clientAddresses = _interopRequireWildcard(require("./redux/clientAddresses"));

exports.clientAddresses = clientAddresses;

var clientBankAccounts = _interopRequireWildcard(require("./redux/clientBankAccounts"));

exports.clientBankAccounts = clientBankAccounts;

var clientGroups = _interopRequireWildcard(require("./redux/clientGroups"));

exports.clientGroups = clientGroups;

var clientNotes = _interopRequireWildcard(require("./redux/clientNotes"));

exports.clientNotes = clientNotes;

var clientPermissions = _interopRequireWildcard(require("./redux/clientPermissions"));

exports.clientPermissions = clientPermissions;

var clients = _interopRequireWildcard(require("./redux/clients"));

exports.clients = clients;

var companies = _interopRequireWildcard(require("./redux/companies"));

exports.companies = companies;

var contactPersons = _interopRequireWildcard(require("./redux/contactPersons"));

exports.contactPersons = contactPersons;

var contracts = _interopRequireWildcard(require("./redux/contracts"));

exports.contracts = contracts;

var devices = _interopRequireWildcard(require("./redux/devices"));

exports.devices = devices;

var documents = _interopRequireWildcard(require("./redux/documents"));

exports.documents = documents;

var documentSeries = _interopRequireWildcard(require("./redux/documentSeries"));

exports.documentSeries = documentSeries;

var documentTemplates = _interopRequireWildcard(require("./redux/documentTemplates"));

exports.documentTemplates = documentTemplates;

var documentVersions = _interopRequireWildcard(require("./redux/documentVersions"));

exports.documentVersions = documentVersions;

var emails = _interopRequireWildcard(require("./redux/emails"));

exports.emails = emails;

var empowerments = _interopRequireWildcard(require("./redux/empowerments"));

exports.empowerments = empowerments;

var entities = _interopRequireWildcard(require("./redux/entities"));

exports.entities = entities;

var entityPlans = _interopRequireWildcard(require("./redux/entityPlans"));

exports.entityPlans = entityPlans;

var entityPreferences = _interopRequireWildcard(require("./redux/entityPreferences"));

exports.entityPreferences = entityPreferences;

var entityProfiles = _interopRequireWildcard(require("./redux/entityProfiles"));

exports.entityProfiles = entityProfiles;

var entityReports = _interopRequireWildcard(require("./redux/entityReports"));

exports.entityReports = entityReports;

var errors = _interopRequireWildcard(require("./redux/errors"));

exports.errors = errors;

var geo = _interopRequireWildcard(require("./redux/geo"));

exports.geo = geo;

var googleCalendars = _interopRequireWildcard(require("./redux/googleCalendars"));

exports.googleCalendars = googleCalendars;

var googleProfile = _interopRequireWildcard(require("./redux/googleProfile"));

exports.googleProfile = googleProfile;

var groups = _interopRequireWildcard(require("./redux/groups"));

exports.groups = groups;

var hearings = _interopRequireWildcard(require("./redux/hearings"));

exports.hearings = hearings;

var iapTransactions = _interopRequireWildcard(require("./redux/iapTransactions"));

exports.iapTransactions = iapTransactions;

var legalObjectCategories = _interopRequireWildcard(require("./redux/legalObjectCategories"));

exports.legalObjectCategories = legalObjectCategories;

var legalObjects = _interopRequireWildcard(require("./redux/legalObjects"));

exports.legalObjects = legalObjects;

var litigations = _interopRequireWildcard(require("./redux/litigations"));

exports.litigations = litigations;

var localConfigs = _interopRequireWildcard(require("./redux/localConfigs"));

exports.localConfigs = localConfigs;

var logs = _interopRequireWildcard(require("./redux/logs"));

exports.logs = logs;

var notifications = _interopRequireWildcard(require("./redux/notifications"));

exports.notifications = notifications;

var parties = _interopRequireWildcard(require("./redux/parties"));

exports.parties = parties;

var partySubscriptions = _interopRequireWildcard(require("./redux/partySubscriptions"));

exports.partySubscriptions = partySubscriptions;

var permissions = _interopRequireWildcard(require("./redux/permissions"));

exports.permissions = permissions;

var personRoles = _interopRequireWildcard(require("./redux/personRoles"));

exports.personRoles = personRoles;

var persons = _interopRequireWildcard(require("./redux/persons"));

exports.persons = persons;

var phases = _interopRequireWildcard(require("./redux/phases"));

exports.phases = phases;

var plans = _interopRequireWildcard(require("./redux/plans"));

exports.plans = plans;

var projectNotes = _interopRequireWildcard(require("./redux/projectNotes"));

exports.projectNotes = projectNotes;

var projectPermissions = _interopRequireWildcard(require("./redux/projectPermissions"));

exports.projectPermissions = projectPermissions;

var projects = _interopRequireWildcard(require("./redux/projects"));

exports.projects = projects;

var promoCodeUsages = _interopRequireWildcard(require("./redux/promoCodeUsages"));

exports.promoCodeUsages = promoCodeUsages;

var spec = _interopRequireWildcard(require("./redux/spec"));

exports.spec = spec;

var subscriptions = _interopRequireWildcard(require("./redux/subscriptions"));

exports.subscriptions = subscriptions;

var tasks = _interopRequireWildcard(require("./redux/tasks"));

exports.tasks = tasks;

var taskTimeLogs = _interopRequireWildcard(require("./redux/taskTimeLogs"));

exports.taskTimeLogs = taskTimeLogs;

var terms = _interopRequireWildcard(require("./redux/terms"));

exports.terms = terms;

var termsResponses = _interopRequireWildcard(require("./redux/termsResponses"));

exports.termsResponses = termsResponses;

var tickets = _interopRequireWildcard(require("./redux/tickets"));

exports.tickets = tickets;

var users = _interopRequireWildcard(require("./redux/users"));

exports.users = users;

var usersEntity = _interopRequireWildcard(require("./redux/usersEntity"));

exports.usersEntity = usersEntity;

var usersPreferences = _interopRequireWildcard(require("./redux/usersPreferences"));

exports.usersPreferences = usersPreferences;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }